import React from "react";
import Carousel from "react-multi-carousel-18";
import "react-multi-carousel-18/lib/styles.css";
import "./index.css";

const FeedsCarousel = ({ feeds, children }) => {
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };

  return feeds.length > 3 ? (
    <div style={{ width: "60vw" }}>
      <Carousel
        responsive={responsive}
        infinite={true}
        containerClass="carousel-cont"
        itemClass="carousel-item-padding-40-px"
        ssr={true}
        keyBoardControl={true}
        customTransition="all .5s"
        transitionDuration={500}
        removeArrowOnDeviceType={["tablet", "mobile"]}
      >
        {children}
      </Carousel>
    </div>
  ) : (
    <div className="d-flex flex-wrap">{children}</div>
  );
};

export default FeedsCarousel;
